var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibility({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77489 15.8956C2.92496 14.7914 2.5 14.2394 2.5 12.6C2.5 10.9606 2.92496 10.4085 3.77489 9.30431C5.47196 7.09953 8.31811 4.59998 12.5 4.59998C16.6819 4.59998 19.528 7.09953 21.2251 9.30431C22.075 10.4085 22.5 10.9606 22.5 12.6C22.5 14.2394 22.075 14.7914 21.2251 15.8956C19.528 18.1004 16.6819 20.6 12.5 20.6C8.31811 20.6 5.47196 18.1004 3.77489 15.8956Z",
    stroke: "#D3D3D3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.6C15.5 14.2568 14.1569 15.6 12.5 15.6C10.8431 15.6 9.5 14.2568 9.5 12.6C9.5 10.9431 10.8431 9.59998 12.5 9.59998C14.1569 9.59998 15.5 10.9431 15.5 12.6Z",
    stroke: "#D3D3D3",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.e52fb320c8f5b860d223c7cdaf6b99af.svg";
export { ForwardRef as ReactComponent };